import { Stack, Typography, Button } from '@mui/material'
import { routes } from '../../routes'
import LockResetIcon from '@mui/icons-material/LockReset';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EMAIL_STORAGE } from '../../components/forgotPassword/CodeReset';

interface SummaryPage {
    count: number;
}
const SummaryPage = ({ count }: SummaryPage) => {
    const navigate = useNavigate();
    const { t } = useTranslation();


    return (
        <Stack spacing={2} justifyContent="center" alignItems="center" useFlexGap sx={{ mt: 5 }}>
            <Typography variant="h5">{t("table.user.resetPasswordValidationMessage")}
            </Typography>
            {<LockResetIcon sx={{ fontSize: 100 }} />}
            <Typography variant="h6">{t("login.logout")}  {count} </Typography>
            <Button onClick={() => {
                localStorage.setItem(EMAIL_STORAGE, "");
                navigate(routes.login)
            }}>{t("login.getin")} </Button>
        </Stack>
    )
}

export default SummaryPage